module.exports = __webpack_public_path__ + "static/media/CV.3db912f0.pdf";